import React, { useEffect } from "react";
import BreadcrumbArea from "../components/BreadcrumbArea/BreadcrumbArea";
import ContactMapArea from "../components/Contact/ContactMapArea";
import ContactPageArea from "../components/Contact/ContactPageArea";
import Layout from "../layouts/Layout";
import { gsapTitleAnimation } from "../lib/gsap-lib/gsapTitleAnimation";

const ContactPage = () => {
  useEffect(() => {
    gsapTitleAnimation();
  }, []);

  return (
    <Layout header={1} footer={1}>
      <BreadcrumbArea
        title={"Contact Our Handyman & Home Renovation Team in Kuala Lumpur"}
        subtitle={"Contact Handyman Services Malaysia"}
      />
      <ContactPageArea />
      <ContactMapArea />
    </Layout>
  );
};

export default ContactPage;
